// Node Modules
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Themes
import theme from '@/themes/index';

const Header = ({
  content: {
    title,
    locationName, 
  },
  shareText, 
}) => {
  return (
    <>
      <h3>{title}</h3>
      <div className='location-name'>
        <p>{locationName}</p>
        <div>
          <FontAwesomeIcon icon={['fa', 'share']} className='share-icon' />
          <a>{shareText}</a>
        </div>
      </div>
      <style jsx>{`
        h3 {
          font-family: ${theme.fontFamilies.montserrat};
          margin-block-end: 0;
          margin-block-start: 0;
        }

        div.location-name {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: flex-end;
        }

        div.location-name div {
          position: relative;
          display: flex;
        }

        div.location-name div a {
          margin-left: 1.2em;
          color: #6e38f7;
          text-decoration: underline;
          cursor: pointer;
        }

        div.location-name p {
          margin-block-end: 0;
        }

        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          div.location-name {
            margin-bottom: 2em;
          }

          div.location-name p {
            font-size: 1.25rem;
            margin-block-start: 0;
          }
        }
      `}</style>
      <style global jsx>{`
        div.location-name div svg.share-icon {
          position: absolute;
          top: 6px;
          font-size: 1.5em;
          color: #6e38f7;
        }
      `}</style>
    </>
  );
};

export default Header;
